import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pannello-info',
  templateUrl: './pannello-info.component.html',
  styleUrls: ['./pannello-info.component.css']
})
export class PannelloInfoComponent {
  @Input() title: any;
  @Input() content: any;
  @Input() values: any;
  @Input() icon: any;
  @Input() type: 'CONFIRM' | 'DELETE' | 'PRIMARY';
  @Input() align: 'CENTER' | 'LEFT' | 'RIGHT';
  @Input() href: boolean;
  @Input() link: any;
  @Input() claim: boolean;

  getClasses() {
    let classes = '';
    classes += this.type;
    classes += ' ' + this.align;
    if (this.claim) {
      classes += ' claim';
    }

    return classes;
  }
}